import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';

// Set up global vars
let isInitialized = false;

/**
 * @class TargetedContentBootstrapUtility
 */
class TargetedContentBootstrapUtility {
  /**
   * Constructor
   */
  constructor() {
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
  }

  /**
   * Initialize the utility
   *
   * @returns {void}
   */
  init() {
    if (isInitialized) return;
    isInitialized = true;
  }
}
var index = new TargetedContentBootstrapUtility();

export { index as default };
